export enum BookId {
    Bronte = "bronte",
    Dickens = "dickens",
    Shelley = "shelley",
    Hurston = "hurston",
    Bly = "bly",
}
